module.exports = __webpack_public_path__ + "img/bg_people_home_01_big.83366f4c.png";